// extracted by mini-css-extract-plugin
module.exports = {"default":"idt-input_default__3ghxo","invalid":"idt-input_invalid__25bn0","input":"idt-input_input__265la","label":"idt-input_label__2dn2o","feedback":"idt-input_feedback__11gpx"};